import React, { Component } from 'react'
import PopIn from './PopIn'
import { injectIntl, defineMessages } from "react-intl"

class PopInVideoPack extends Component {

  render() {
    const {intl:{formatMessage}} = this.props

    return (
      <PopIn
        closePopIn={() => this.props.closePopIn()}
        title={formatMessage(messages.title)}
      >
        <div className="pop-in-video-pack">
          <p>{formatMessage(messages.content1)}</p>
          <p>{formatMessage(messages.content2)}</p>
          <p>{formatMessage(messages.content8)} <strong>{formatMessage(messages.content3)}</strong> : {formatMessage(messages.content4)} <strong>{formatMessage(messages.content5)}</strong> {formatMessage(messages.content6)}</p>
          <p>{formatMessage(messages.content7)}</p>
          <p className="pop-in-video-pack-notice">{formatMessage(messages.notice)}</p>
        </div>
      </PopIn>
    )
  }
}

const messages = defineMessages({
  title: {
    id: 'popinVideoPack.contentTitle',
    defaultMessage: 'Pack vidéo "Lost Asylum"'
  },
  content1: {
    id: 'popinVideoPack.content1',
    defaultMessage: 'Revivez votre cauchemar.'
  },
  content2: {
    id: 'popinVideoPack.content2',
    defaultMessage: 'Chaque cri, chaque hésitation, chaque éclat de rire a été capturé.'
  },
  content3: {
    id: 'popinVideoPack.content3',
    defaultMessage: 'film souvenir de votre aventure'
  },
  content4: {
    id: 'popinVideoPack.content4',
    defaultMessage: 'un montage exclusif d’environ'
  },
  content5: {
    id: 'popinVideoPack.content5',
    defaultMessage: '10 minutes'
  },
  content6: {
    id: 'popinVideoPack.content6',
    defaultMessage: 'réunissant les scènes les plus mémorables de votre équipe.'
  },
  content7: {
    id: 'popinVideoPack.content7',
    defaultMessage: 'Parce que certaines expériences méritent d’être revécues... et montrées à ceux qui pensent qu’ils auraient fait mieux.'
  },
  content8: {
    id: 'popinVideoPack.content8',
    defaultMessage: 'Grâce à nos caméras, repartez avec un'
  },
  notice: {
    id: 'popinVideoPack.notice',
    defaultMessage: 'Votre vidéo est envoyée par email sous 72 h. Cette vidéo est réservée à un usage privé et personnel. Toute diffusion ou utilisation commerciale est interdite.'
  },
})

export default injectIntl(PopInVideoPack)



// WEBPACK FOOTER //
// ./src/components/PopInVideoPack.js